
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-12 col-md-12 col-xs-12" style="padding-left:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
                        <!-- SFTP Client Configuration -->
                        <div class="col-lg-6 col-md-6 col-xs-12" style="margin-bottom:0px;">
                            <h4>SFTP Client Settings</h4>
                            <div class="form-group">
                                <p class="custom-label">Host</p>
                                <input type="text" formControlName="host" class="form-control" [readonly]="isHostedServer" [placeholder]="isHostedServer && !editMode ? 'Assigned automatically' : 'sftp.example.com'">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Port</p>
                                <input type="number" formControlName="port" class="form-control" [readonly]="isHostedServer" placeholder="22">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Username</p>
                                <div [class.input-group]="isHostedServer">
                                    <input type="text" formControlName="username" class="form-control" [readonly]="isHostedServer">
                                    <span class="input-group-btn" *ngIf="isHostedServer">
                                        <button class="btn btn-default" type="button" (click)="copyUsername()" title="Copy username">
                                            <span class="glyphicon glyphicon-copy"></span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <p class="custom-label">Password</p>
                                <div class="input-group">
                                    <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="form-control" [readonly]="isHostedServer">
                                    <span class="input-group-btn">
                                        <button class="btn btn-default" type="button" (click)="showPassword = !showPassword" [title]="showPassword ? 'Hide password' : 'Show password'">
                                            <span class="glyphicon" [ngClass]="showPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'"></span>
                                        </button>
                                        <button *ngIf="isHostedServer" class="btn btn-default" type="button" (click)="copyPassword()" title="Copy password">
                                            <span class="glyphicon glyphicon-copy"></span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="isHostedServer && !editMode" style="margin-top: 10px; margin-bottom: 15px;">
                                <button type="button" class="btn btn-default btn-sm" (click)="regenerateCredentials()">
                                    <span class="glyphicon glyphicon-refresh"></span> Regenerate Credentials
                                </button>
                            </div>
                        </div>

                        <!-- SFTP File Configuration -->
                        <div class="col-lg-6 col-md-6 col-xs-12">
                            <h4>File Settings</h4>
                            <div class="form-group" *ngIf="!isHostedServer">
                                <p class="custom-label">Remote Path</p>
                                <input type="text" formControlName="remotePath" class="form-control" placeholder="/outbox">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">File Pattern</p>
                                <input type="text" formControlName="fileNamePattern" class="form-control" placeholder="*.csv">
                            </div>

                            <!-- CSV Mapper inside File Settings for Hosted SFTP Server mode -->
                            <div class="form-group" *ngIf="isHostedServer" style="margin-top: 15px;">
                                <p class="custom-label">
                                    <a style="cursor: pointer; font-size: 13px;" (click)="showCsvMapper = !showCsvMapper">
                                        {{ showCsvMapper ? 'Hide' : 'Show' }} CSV Mapper
                                    </a>
                                </p>
                                <div [hidden]="!showCsvMapper">
                                    <textarea formControlName="csvMappingJson" class="form-control" style="height: 195px; resize: vertical;" placeholder='{ "csvMappingConfigs": [...] }'></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CSV Mapper in bottom row for Default / External mode -->
                    <div class="row" *ngIf="!isHostedServer">
                        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-bottom:0px;">
                            <h4>
                                <a style="cursor: pointer; font-size: 14px;" (click)="showCsvMapper = !showCsvMapper">
                                    {{ showCsvMapper ? 'Hide' : 'Show' }} CSV Mapper
                                </a>
                            </h4>
                            <div class="form-group" [hidden]="!showCsvMapper">
                                <textarea formControlName="csvMappingJson" class="form-control" rows="10" placeholder='{ "csvMappingConfigs": [...] }'></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
                <button *ngIf="!isHostedServer" style="margin-left:10px;" type="button" class="btn btn-large btn-deny" (click)="testConnection()">Test Connection</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
	    </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
    